import React, { useEffect, createContext, ReactNode } from 'react'
import useSetState from 'react-use/lib/useSetState'
import { getDomain } from '@chilipiper/utils'
import { useGetOrganizationName } from './useGetOrganizationName'

export interface BookingState {
  organizationName: string
}

interface BookingContext {
  bookingState?: BookingState
  setBookingState?: (state: Partial<BookingState>) => void
}

export const bookingContext = createContext<BookingContext>({})

interface Props {
  children?: ReactNode
}

export const BookingStateProvider = ({ children }: Props) => {
  const { name = '' } = useGetOrganizationName(getDomain())
  const [state, setState] = useSetState<BookingState>({
    organizationName: name,
  })

  useEffect(() => {
    setState({ organizationName: name })
  }, [name])

  return (
    <bookingContext.Provider
      value={{
        bookingState: state,
        setBookingState: setState,
      }}
    >
      {children}
    </bookingContext.Provider>
  )
}
